import { useEffect, useState } from 'react'
import {
  Item,
  onChangeEvent,
} from '../../../../../utils/types/generals'
import { searchInModeLower } from '../../../../../utils/validate/validate'

const useFilter = ({
  lists,
  steps,
}: {
  steps: string | number
  lists: Record<string, Record<string, string | number | undefined | null>[]>
}) => {
  const [filterData, setFilterData] = useState<Record<string, any>>({})
  const [row, setRow] = useState<unknown[]>([])
  const [counter, setCounter] = useState<Record<string, number | null>>({})


  const handleFilter = (data?: {
    e?: onChangeEvent
    payload?: { clean: boolean }
  }) => {
    const e = data?.e,
      payload = data?.payload

    let name: string, value: any
    let body = {
      ...(filterData[steps] ?? {}),
    }

    if (e?.target) {
      name = e?.target.name
      value = e?.target.value
      body = {
        ...body,
        [name]: value,
      }
      setFilterData((prev) => ({
        ...prev,
        [steps]: {
          ...(prev?.[steps] ?? {}),
          [name]: value,
        },
      }))
    }

    if (!!payload?.clean) {
      body = {}
    }

    const filterLIst: Record<string, () => unknown[]> = {
      0: () => {
        const list = lists.users?.filter((item) =>
          !!(body?.userType?.length ? !!body?.userType?.some((itemUserType: Item) => itemUserType.value == item.userTypeId) : true) &&
          !!searchInModeLower(
            [
              item?.fullname ?? '',
              item?.curp ?? '',
              item?.userType ?? '',
              item?.email ?? '',
              item?.phone ?? '',
            ].join(' '),
            body.search ?? ''
          )
        )

        return list
      },
      1: () => {
        return lists.questionnaires?.filter((item) =>
          !!(body?.types?.length ? body?.types?.some((itemactionType: Item) => itemactionType.value == item.actionType) : true) &&
          searchInModeLower(
            [
              item?.questionnaireName ?? '',
              item?.askAmount ?? '',
              item?.actionPlan ?? '',
              item?.appAmount ?? '',
            ].join(' '),
            body.search
          )
        )
      },
    }

    const listFiltered = filterLIst[steps]()

    setRow(listFiltered)

    return listFiltered
  }

  const handleCheanFilter = () => {
    setFilterData({})
    handleFilter({ payload: { clean: true } })
  }

  useEffect(() => {
    setCounter({})
    let count = 0
    for (let key in filterData[steps]) {
      if (filterData[steps][key] instanceof Array) {
        if (filterData[steps][key]?.length > 0) count++
      } else if (
        filterData[steps][key] != null &&
        filterData[steps][key] !== ''
      )
        count++
    }

    setCounter((prev) => ({
      ...prev,
      [steps]: count,
    }))
  }, [filterData])

  useEffect(() => {
    handleFilter()
  }, [steps, lists])

  return {
    filterData,
    row,
    counter: counter[steps],
    handleFilter,
    handleCheanFilter,
  }
}

export { useFilter }
